<template>
  <footer class="footer mt-6">
    <div class="container is-max-widescreen">
      <img src="../assets/kn_logo_standard_negative_rgb.svg" alt="Go to Kuehne+Nagel" width="297" height="58">
      <hr>
      <a href="https://privacy.kuehne-nagel.com/privacy-policy/">Privacy Policy</a>
    </div>
  </footer>
</template>
<style lang="scss" scoped>
@import '@/theme/theme.scss';

a {
  color: $color-brand-secondary;
}

a:hover {
  color: $color-functional-blue;
}
</style>
